/** 文件校验规则，大小单位为 MB。 */
export interface FileRule { accept?: string[]; maxSizeMb?: number }
/** 同时兼容 MIME 与 `.后缀` 白名单，复刻旧上传组件行为。 */
export function validateFile(file: File, rule: FileRule): string | undefined {
    const suffix = `.${file.name.split(".").pop()?.toLowerCase() ?? ""}`;
    if (rule.accept?.length && !rule.accept.includes(file.type) && !rule.accept.map(item => item.toLowerCase()).includes(suffix)) return `仅支持 ${rule.accept.join(",")} 文件`;
    if (rule.maxSizeMb != null && file.size / 1024 / 1024 > rule.maxSizeMb) return `文件大小不能超过 ${rule.maxSizeMb}M`;
    return undefined;
}
